import { LS_ROUTE_KEY } from '@/Setup/Routes/SetupRouter.js'
import store from '@/Setup/SetupStore.js'
import { AUTH_USER_GETTER } from '@/Modules/Auth/AuthModule.js'

export default function guest({ next, router }) {
  if (localStorage.getItem('auth_token')) {
    let lastRoutePath

    try {
      const stored = JSON.parse(sessionStorage.getItem(LS_ROUTE_KEY))
      const currentUser = store.getters[`AuthModule/${AUTH_USER_GETTER}`]
      if (stored && (stored.userId === null || stored.userId === currentUser?.id)) {
        lastRoutePath = stored.path
      }
    } catch (error) {
      console.error(error)
    }

    if (lastRoutePath) {
      return router.push({ path: lastRoutePath })
    }

    return router.push({ name: 'home' })
  }

  return next()
}
